<template>
  <el-container class="contract" >

    <el-header class="header-style">
    <el-divider content-position="left">合同列表</el-divider>
    <el-row>
      <el-col :span="20">
        <el-select v-model="searchArr.flow_name"
          filterable remote reserve-keyword
          placeholder="请输入合同名称筛选"
          size="mini" clearable
          :remote-method="searchRemoteFlowNameMethod"
          :loading="searchLoading"
          @change="handleSearchFlowNameChange">
          <el-option v-for="searchFlow in searchFlows"
          :key="searchFlow.id"
          :label="searchFlow.flow_name"
          :value="searchFlow.id">
          </el-option>
        </el-select>
        <el-popover placement="bottom-start" v-model="visible" width="320">
          <el-form :model="searchArr" ref="searchForm" label-width="100px">
            <el-form-item label="发起方" prop="tx_company_id">
              <el-select v-model="searchArr.tx_company_id"
                filterable
                placeholder="请输入发起方名称筛选"
                size="mini"
                clearable>
                <el-option v-for="company in txElectronicCompanies"
                :key="company.id"
                :label="company.organization_name"
                :value="company.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发起人" prop="operator_id">
              <el-select v-model="searchArr.operator_id"
                filterable
                placeholder="请输入发起方名称筛选"
                size="mini"
                clearable>
                <el-option v-for="adminUser in adminUsers"
                :key="adminUser.id"
                :label="adminUser.username"
                :value="adminUser.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="个人签署方" prop="uid">
              <el-select v-model="searchArr.uid"
                filterable remote reserve-keyword
                placeholder="请输入姓名筛选个人签署方"
                size="mini" clearable
                :remote-method="searchRemoteUserMethod"
                :loading="searchUserLoading">
                <el-option v-for="searchUser in searchUsers"
                :key="searchUser.id"
                :label="searchUser.nickname"
                :value="searchUser.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="企业签署方" prop="company_id">
              <el-select v-model="searchArr.company_id"
                filterable remote reserve-keyword
                placeholder="请输入公司名称筛选公司"
                size="mini" clearable
                :remote-method="searchRemoteCompanyMethod"
                :loading="searchCompanyLoading">
                <el-option v-for="searchCompany in searchCompanies"
                :key="searchCompany.id"
                :label="searchCompany.company_name"
                :value="searchCompany.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同状态" prop="flow_status">
              <el-select v-model="searchArr.flow_status" placeholder="合同状态" clearable size="mini">
                <el-option label="合同签署中" value="PART"></el-option>
                <el-option label="合同签署完成" value="ALL"></el-option>
                <el-option label="合同拒签" value="REJECT"></el-option>
                <el-option label="合同撤回" value="CANCEL"></el-option>
                <el-option label="合同即将过期" value="WILLEXPIRE"></el-option>
                <el-option label="合同过期" value="DEADLINE"></el-option>
                <el-option label="解除协议" value="RELIEVED"></el-option>
                <el-option label="合同异常" value="EXCEPTION"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="tr">
              <el-button @click="resetForm('searchForm')" size="mini">重置</el-button>
              <el-button type="primary" @click="submitForm('searchForm')" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button slot="reference" size="mini">筛选</el-button>
        </el-popover>
      </el-col>
    </el-row>
  </el-header>

  <el-main class="main-style">
    <el-table height="calc(100vh - 276px)" :data="pageData" size="mini" border style="width: 100%;" v-cloak>
      <el-table-column label="合同名称" prop="flow_name" fixed>
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.flow_name" placement="top" :open-delay="500">
            <span class="hide-style">{{ scope.row.flow_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发起方">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.tx_company.organization_name" placement="top" :open-delay="500">
            <span class="hide-style">{{ scope.row.tx_company.organization_name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="发起人">
        <template slot-scope="scope">
          <span class="hide-style">{{ scope.row.admin_user.username }}</span>
        </template>
      </el-table-column>
      <el-table-column label="签署方">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.approvers" :key="index">
            <el-tooltip class="item"  effect="dark" :content="getOrganizationName(scope.row.tx_company.organization_name, item, scope.row.company, scope.row.type)" placement="top" :open-delay="500">
              <span class="hide-style">{{ getOrganizationName(scope.row.tx_company.organization_name, item, scope.row.company, scope.row.type) }}</span>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同状态" prop="flow_status">
        <template slot-scope="scope">
          <span>{{ scope.row.flow_status }}</span>
        </template>
      </el-table-column>
      <el-table-column label="合同类型" prop="flow_type"></el-table-column>
      <el-table-column prop="bind_order_no" label="关联订单号" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.bind_order_no" style="display: inline-block;text-align: left;width: 105px;padding: 0.18rem 0;">
            <span>{{ scope.row.bind_order_no }}</span>
          </div>
          <div v-else style="display: inline-block; text-align: left; width: 25px">
            <i class="el-icon-circle-plus-outline" style="font-size: 0.43rem;cursor: pointer;vertical-align: middle;"
              title="关联订单号" @click="openBind(scope.row)"></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="发起时间" prop="created_at" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.created_at" placement="top" :open-delay="500">
            <!-- <span class="hide-style">{{ scope.row.created_at }}</span> -->
            <date-formatter :date-value="scope.row.created_at"></date-formatter>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="过期时间" prop="dead_line" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" :content="scope.row.dead_line" placement="top" :open-delay="500">
            <!-- <span class="hide-style">{{ scope.row.dead_line }}</span> -->
            <date-formatter :date-value="scope.row.dead_line"></date-formatter>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" content="下载合同" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-download" circle @click="handpreviewOpen(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item"  effect="dark" content="撤销" placement="top" v-if="scope.row.flow_status === '合同创建' || scope.row.flow_status === '合同签署中' || scope.row.flow_status === '合同即将过期'">
            <el-button type="danger" size="mini" icon="el-icon-close" circle @click="handRevoke(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item"  effect="dark" content="生成合同二维码" placement="top" v-if="scope.row.flow_status === '合同创建' || scope.row.flow_status === '合同签署中' || scope.row.flow_status === '合同即将过期'">
            <el-button type="success" size="mini" icon="el-icon-menu" circle @click="handQrCodeOpen(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </el-main>


  <el-footer class="footer-style">
    <el-pagination
      background
      class="tr mt-10"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </el-footer>

    <el-dialog title="合同二维码" :visible.sync="qrCodeVisible" :before-close="handleQrCodeClose" width="30%">
      <el-row class="text-align-c">
        <el-image :src="qrCode" style="border: 1px solid #ddd"></el-image>
      </el-row>
      <el-row class="mt-10 text-align-c">
        <span>请 {{ txCompany }} 法人使用认证过的微信扫码</span>
      </el-row>
    </el-dialog>
    <el-dialog title="绑定订单号" :visible.sync="bindOrderNoDrawer" width="30%">
        <el-form>
          <div style="text-align: center">
            <el-form-item>
              <el-input v-model="orderNo.contractContent" clearable></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="doBindOrderNumber">绑定</el-button>
        </div>
    </el-dialog>
  </el-container>
</template>

<script>
import DateFormatter from 'common/DateFormatter'
export default {
  name: 'Contract',
  components: {DateFormatter},
  data () {
    return {
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30 // 每页显示条数
      },
      visible: false,
      searchArr: {
        flow_name: '',
        tx_company_id: '',
        flow_status: '',
        company_id: '',
        uid: '',
        operator_id: ''
      },
      searchLoading: false,
      searchFlows: [],
      searchCompanyLoading: false,
      searchCompanies: [],
      searchUserLoading: false,
      searchUsers: [],
      txElectronicCompanies: [],
      adminUsers: [],
      qrCodeVisible: false,
      qrCode: '',
      txCompany: '',
      bindOrderNoDrawer: false,
      orderNo: {
        contractId: null,
        contractContent: ''
      }
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getPageData () {
      this.$axios.get('/api/admin/qz_electronic_contract_controller?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize + this.searchStr)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.pageData.data
            this.pageOption.total = data.data.pageData.total
            this.txElectronicCompanies = data.data.txElectronicCompanies
            this.adminUsers = data.data.adminUsers
          }
        })
    },
    // 关联订单号
    openBind (row) {
      this.bindOrderNoDrawer = true
      this.orderNo.contractId = row.id
    },
    // 绑定
    doBindOrderNumber () {
      if (this.orderNo.contractContent === '') {
        this.$message.error('未输入要绑定的订单号！')
        return false
      }
      this.$axios
        .post('api/admin/tx_electronics/update_order_no', {
          params: {
            id: this.orderNo.contractId,
            bind_order_no: this.orderNo.contractContent
          }
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.bindOrderNoDrawer = false
            this.orderNo.contractId = null
            this.orderNo.contractContent = ''
            this.getPageData()
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    getOrganizationName (txName, item, company, type) {
      let str = ''
      if (item.organizationName) {
        str = item.organizationName + '_' + item.approveName
      } else {
        str = item.approveName
      }

      return str
    },
    searchRemoteUserMethod (query) {
      if (query !== '') {
        this.searchUserLoading = true
        setTimeout(() => {
          this.searchUserLoading = false
          this.searchArrItemUsers(query)
        }, 200)
      } else {
        this.searchUsers = []
      }
    },
    searchArrItemUsers (query) {
      this.$axios.get('/api/admin/search_electronic_users?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.searchUsers = data.data.searchUsers
          }
        })
    },
    searchRemoteFlowNameMethod (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchArrItemFlows(query)
        }, 200)
      } else {
        this.searchFlows = []
      }
    },
    searchArrItemFlows (query) {
      this.$axios.get('/api/admin/search_electronics?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.searchFlows = data.data.searchFlows
          }
        })
    },
    searchRemoteCompanyMethod (query) {
      if (query !== '') {
        this.searchCompanyLoading = true
        setTimeout(() => {
          this.searchCompanyLoading = false
          this.searchArrItemCompanys(query)
        }, 200)
      } else {
        this.searchCompanies = []
      }
    },
    searchArrItemCompanys (query) {
      this.$axios.get('/api/admin/searchCompany?name=' + query)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.searchCompanies = data.data.companies
          }
        })
    },
    handleSearchFlowNameChange (val) {
      this.visible = false
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    submitForm (formName) {
      this.visible = false
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    resetForm (formName) {
      this.searchArr.flow_name = ''
      this.$refs[formName].resetFields()
      this.pageOption.currentPage = 1
      this.getPageData()
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getPageData()
    },
    handpreviewOpen (row) {
      this.$axios.post('/api/admin/qz_electronic_contract_controller/load/' + row.id)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            window.open(data.data.url)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handRevoke (row) {
      this.$confirm('是否确定撤销?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/api/admin/qz_electronic_contract/cancel_flow/' + row.id)
          .then((res) => {
            let { data } = res
            if (data.code === 0) {
              this.getPageData()
              this.$message.success(data.msg)
            } else {
              this.$message.error(data.msg)
            }
          })
      }).catch(() => {})
    },
    handQrCodeOpen (row) {
      this.$axios.get('/api/admin/qz_electronic_contract/qr_code/' + row.id)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.qrCode = data.data.imgInfo
            this.txCompany = row.tx_company.organization_name
            this.qrCodeVisible = true
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleQrCodeClose (done) {
      this.qrCode = ''
      this.txCompany = ''
      done()
    },
    getFlowStatusMsg (row) {
      let approvers = row.approvers
      let str = row.flow_status

      for (var i = 0; i < approvers.length; i++) {
        if (approvers[i].ApproveCallbackStatus === 4) {
          str = '签署方' + approvers[i].OrganizationName + '由于' + approvers[i].ApproveMessage + '拒签当前合同'
        }
      }

      return str
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.companies >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.contract
  marginLeft()
  max-height: 100vh
  .header-style
    height: 100px !important
    padding: 0px !important
  .main-style
    padding: 0px !important
    // overflow-y: auto
  .footer-style
    text-align: right
    .el-pagination
      padding-top: 15px
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.tr
  text-align: right
.text-align-c
  text-align: center
.mt-10
  margin-top: .2rem
.mt-20
  margin-top: .4rem
.el-form-item
  margin-bottom: .1rem
.el-form .el-select
  width: 100%
// .el-dialog .el-select
//   width: 100%
</style>



// WEBPACK FOOTER //
// src/pages/contract/Contract.vue